/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import * as components from "../components/index.js";

export type ConflictErrorResponseData = {
  meta: components.Meta;
  error: components.BaseError;
};

export class ConflictErrorResponse extends Error {
  meta: components.Meta;
  error: components.BaseError;

  /** The original data that was passed to this error instance. */
  data$: ConflictErrorResponseData;

  constructor(err: ConflictErrorResponseData) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.meta = err.meta;
    this.error = err.error;

    this.name = "ConflictErrorResponse";
  }
}

/** @internal */
export const ConflictErrorResponse$inboundSchema: z.ZodType<
  ConflictErrorResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: components.Meta$inboundSchema,
  error: components.BaseError$inboundSchema,
})
  .transform((v) => {
    return new ConflictErrorResponse(v);
  });

/** @internal */
export type ConflictErrorResponse$Outbound = {
  meta: components.Meta$Outbound;
  error: components.BaseError$Outbound;
};

/** @internal */
export const ConflictErrorResponse$outboundSchema: z.ZodType<
  ConflictErrorResponse$Outbound,
  z.ZodTypeDef,
  ConflictErrorResponse
> = z.instanceof(ConflictErrorResponse)
  .transform(v => v.data$)
  .pipe(z.object({
    meta: components.Meta$outboundSchema,
    error: components.BaseError$outboundSchema,
  }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ConflictErrorResponse$ {
  /** @deprecated use `ConflictErrorResponse$inboundSchema` instead. */
  export const inboundSchema = ConflictErrorResponse$inboundSchema;
  /** @deprecated use `ConflictErrorResponse$outboundSchema` instead. */
  export const outboundSchema = ConflictErrorResponse$outboundSchema;
  /** @deprecated use `ConflictErrorResponse$Outbound` instead. */
  export type Outbound = ConflictErrorResponse$Outbound;
}
